import React from "react";
import './Works.css'
import Html from "../../img/html.png";
import CSS from "../../img/CSS.png";
import JavaScript from "../../img/js.png";
import Redux from "../../img/redux.png";
import AutoCAD from "../../img/auto.png";
import Cpp from "../../img/cpp.png";
import { useContext } from "react";
import { themeContext } from "../../Context";
import {motion} from 'framer-motion'
import { Link } from "react-scroll";


const Works = () => {
    const theme=useContext(themeContext);
    const darkMode=theme.state.darkMode;
    return (
        <div className="works">
       
            <div className="awesome">
                <span style={{color:darkMode?'white':''}}>Skills Developed</span>
                <span>MERN STACK  Web Developer</span>
                <div>
                <span className="text">I have interested in Web Development. <br />
                I have worked with this portfolio and I came across learning new things<br/>
                React js, framermotion, Slider, useEffect, React hooks, HTML5, CSS, JS and many more.
                <br/>
                Secondly, I make NETFLIX_CLONE with reactjs, mongodb, nodejs, <br/>TMDB apis and many mores.
                <br/>Thirdly, I make Pglife after summer training at internshala<br/> where I learned php, reactjs ,bootstrap-reactjs connection, mySQL.<br/>
                Lastly 2 websites with html, css, bootstrap, js.<br/> 
                Many more AUTOCAD projects.<br/>
                MORE TO ADD. Comming soon......

                </span>
                <div>
                <Link spy={true} to='Contact'> 
                <button className="button">Hire Me</button></Link> 
              
                
                </div>
            
                <div className="blur s-blur1" style={{ background: "ABF1FF94" }}></div>
            </div>
        </div>
            {/*rightside*/}
            <div className="w-right">
                <motion.div
                initial={{rotate:45}}
                whileInView={{rotate:0}}
                viewport={{margin:'-40px'}}
                transition={{duration:3.5,type:'spring'}} 
                className="w-mainCircle">
                <motion.div
                 initial={{rotate:360}}
                 whileInView={{rotate:0}}
                 viewport={{margin:'-20px'}}
                 transition={{duration:3.5,type:'spring'}} 
                  className="w-secCircle w-secCircle1">
                    <img src={Html} alt="" /></motion.div>
                <motion.div 
                 initial={{rotate:360}}
                 whileInView={{rotate:0}}
                 viewport={{margin:'-20px'}}
                 transition={{duration:3.5,type:'spring'}} 
                 className="w-secCircle">
                 <img src={CSS}  alt="" /></motion.div>
                <motion.div 
                 initial={{rotate:360}}
                 whileInView={{rotate:0}}
                 viewport={{margin:'-20px'}}
                 transition={{duration:3.5,type:'spring'}} 
                 className="w-secCircle w-sec">
                 <img  src={JavaScript} alt="" /></motion.div>
                <motion.div
                 initial={{rotate:360}}
                 whileInView={{rotate:0}}
                 viewport={{margin:'-20px'}}
                 transition={{duration:3.5,type:'spring'}} 
                  className="w-secCircle w-secCircle1 "><img src={Cpp} alt="" /></motion.div>
               
                <motion.div
                  initial={{rotate:360}}
                  whileInView={{rotate:0}}
                  viewport={{margin:'-20px'}}
                  transition={{duration:3.5,type:'spring'}} 
                 className="w-secCircle"><img  src={Redux} alt=""/></motion.div>
                <motion.div
                  initial={{rotate:360}}
                  whileInView={{rotate:0}}
                  viewport={{margin:'-20px'}}
                  transition={{duration:3.5,type:'spring'}} 
                 className="w-secCircle"><img  src={AutoCAD} alt="" /></motion.div>
               
                

            </motion.div>
            {/*background*/}
                <div className="w-backCircle blueCircle"></div>
                <div className="w-backCircle yellowCircle"></div>
            </div>
            </div>

    );
};
export default Works